export function addMarkup(elem, html) {
  elem.innerHTML = html;
}
